import { ReactQueryDevtools } from "@tanstack/react-query-devtools";

import { showQueryDevTools } from "@/config/environmentUtils";

export const QueryDevTools = () => {
  if (!showQueryDevTools()) return null;

  return <ReactQueryDevtools initialIsOpen={false} />;
};
